export enum OHIFViewerModeType {
  IMAGING_SPECIALIST = 'ImagingSpecialist',
  SIMPLE_VIEWER = 'SimpleViewer',
  READER = 'Reader',
}

export type DICOMImageData = {
  seriesInstanceUID: string;
  seriesId: string;
  sliceNumber?: number;
  studyInstanceUID: string;
  visitId: string;
  taskId: string;
};
